<app-fancy-table #table prefix="admin.users.table." [options]="options" [items]="page?.users"></app-fancy-table>
<app-paging (pageChanged)="toPage($event)" [current]="page?.criteria.page" [last]="page?.lastPage"></app-paging>
<div class="bulk-actions text-right middle">
  <span class="mr-2">{{ prefix + 'bulk-actions-label' | translate : { count: table.selectCount } }}</span>
  <button (click)="bulkDelete()" [disabled]="table.selectCount === 0" type="button" class="btn btn-danger">
    <i class="fa fa-trash"></i>
    {{ prefix + 'bulk-delete' | translate : { count: table.selectCount } }}
  </button>
</div>
